// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
    <customer-credit-line-details
      credit-line="\$ctrl.creditLine"
      form="\$ctrl.creditLineForm"
    >
    </customer-credit-line-details>

    <div class="clearfix"></div>
    <div class="flex-end">
      <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
      <button class="btn btn-primary" ng-click="\$ctrl.postCreditLine()" ng-disabled="\$ctrl.creditLineForm.\$invalid">Open</button>
    </div>

</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/credit-line/new-credit-line/customer-credit-line-create.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;